var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsBurger = function SvgLeonInmobiliariaIconsBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "leon-inmobiliaria-icons-burger_svg__Burger",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159.79 159.77"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-burger_svg__cls-1{fill:none;stroke:currentcolor;stroke-width:6.76px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-burger_svg__Gruppe_9056",
    "data-name": "Gruppe 9056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-burger_svg__Linie_177",
    "data-name": "Linie 177",
    className: "leon-inmobiliaria-icons-burger_svg__cls-1",
    d: "M38.49 54.34h79.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-burger_svg__Linie_178",
    "data-name": "Linie 178",
    className: "leon-inmobiliaria-icons-burger_svg__cls-1",
    d: "M38.49 79.84h79.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-burger_svg__Linie_179",
    "data-name": "Linie 179",
    className: "leon-inmobiliaria-icons-burger_svg__cls-1",
    d: "M38.49 105.34h79.88"
  }))));
};
export default SvgLeonInmobiliariaIconsBurger;